import { cn } from 'lib/utils'
import { FormError } from 'components/atoms/FormError'
import { TextareaHTMLAttributes } from 'react'

const mainClass = 'form'

export interface TextareaProps extends Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  'className'
> {
  error?: string
  className?: string
}

export const Textarea = ({
  error,
  className,

  ...textareaProps
}: TextareaProps) => {
  return (
    <div className={`${mainClass}__group`}>
      <textarea
        {...textareaProps}
        className={cn(`${mainClass}__control`, className)}
      />
      {error && <FormError message={error} />}
    </div>
  )
}
